import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app';
// Este import é crucial: ele aponta para o arquivo que gerencia o ciclo de vida do SW
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Global.css';
import './styles/bootstrap-screens.css';

window.addEventListener('error', (e) => {
  if (e.message?.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
  }
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<App />);

serviceWorker.register({
  onUpdate: (registration) => {
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      registration.waiting.addEventListener('statechange', (e) => {
        if (e.target.state === 'activated') {
          window.location.reload();
        }
      });
    }
  },
});